/*
 * Frontend-Script für den Block.
 */
